import { Component, Input, OnInit } from '@angular/core';
import { IAccount } from 'src/app/models/IAccount.model';
import { AccountsService } from 'src/app/services/accounts.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})


export class HeaderComponent implements OnInit {

  @Input() account_id: string = '-1';

  public account: IAccount;
  public clickMessage: string = '';
  public toolbarWidth = 100;

  // v2.14.2: rimosso `clickedId` + `goToDetails()` + DI OpenModalService.
  // Erano dead code — chiamavano `<app-gestione-account-dettagli>` che
  // è stato rimosso in v2.3.0. Il flow "apri dettaglio account" ora
  // vive solo in SidebarComponent (navigazione a /accounts).

  constructor(
    public authServ: AuthService,
    public accServ: AccountsService
  ) { }

  ngOnInit(): void { }

  public splitButtonData: Array<{ [key: string]: unknown }> = [
    {
      text: 'Impostazioni',
      icon: 'k-i-cog',
      click: (): void => this.onItemClick('Impostazioni clicked'),
    },
    {
      text: 'Logout',
      icon: 'paste-as-html',
      click: (): void => this.onItemClick('Logout button clicked'),
    },
  ];

  public dropdownButtonData: Array<{ [key: string]: unknown }> = [
    {
      text: 'Impostazioni',
      icon: 'k-i-cog',
      click: (): void => this.onItemClick('Impostazioni clicked'),
    },
    {
      text: 'Logout',
      icon: 'paste-as-html',
      click: (): void => this.onItemClick('Logout button clicked'),
    },
  ];

  public onItemClick(message: string): void {
    this.clickMessage = message;
  }
  
}
